import SectionHeading from './SectionHeading';
import { topicTags } from '@/mocks/home';

const metrics = [
  { id: 1, label: '今日更新条目', value: '1,286', hint: '较昨日 +18%' },
  { id: 2, label: '正在进行讨论', value: '342', hint: '涉及 26 个话题' },
  { id: 3, label: '平均首发速度', value: '2分18秒', hint: '从线索到发布' },
];

export default function Topics() {
  return (
    <section id="topics" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <SectionHeading
          eyebrow="HOT TOPICS"
          title="今日热门话题"
          desc="关键词自动聚类，点进去就是对应的实时内容与讨论。"
        />

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_320px] lg:gap-10">
          <div className="flex flex-wrap gap-3">
            {topicTags.map((tag) => (
              <a
                key={tag.id}
                href="#stream"
                className="group flex min-w-[150px] flex-1 flex-col rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <span className="flex items-center gap-1 font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
                  <span className="text-primary-500">#</span>
                  {tag.label}
                </span>
                <span className="mt-1.5 text-xs text-foreground-500">{tag.count}</span>
              </a>
            ))}
          </div>

          <aside className="flex flex-col gap-4">
            <div className="rounded-lg bg-accent-500 p-5 text-background-950">
              <span className="text-xs font-medium tracking-wide">今日最活跃话题</span>
              <p className="mt-2 font-heading text-xl font-bold">#免费看料今日</p>
              <p className="mt-1 text-sm text-background-950/80">2.4 万条讨论 · 依旧在涨</p>
            </div>
            <div className="rounded-lg border border-background-200/80 bg-background-100/60 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">今日数据</h3>
              <ul className="mt-4 flex flex-col gap-4">
                {metrics.map((m) => (
                  <li key={m.id} className="flex items-end justify-between gap-3 border-b border-background-200/70 pb-3 last:border-0 last:pb-0">
                    <div>
                      <p className="text-xs text-foreground-500">{m.label}</p>
                      <p className="mt-0.5 text-[11px] text-secondary-700">{m.hint}</p>
                    </div>
                    <span className="font-heading text-xl font-bold text-foreground-950">{m.value}</span>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}